module.exports = __webpack_public_path__ + "static/media/direction.a704d211.svg";